var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.status)+"\n  ")]},null,{ status: _vm.status, isReady: _vm.isReady, isLoading: _vm.isLoading, isProcessing: _vm.isProcessing })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }